import Vue from 'vue'
import VueRouter from 'vue-router'
import First from '../views/First.vue'
import Questions from '../views/Questions.vue'
import Results from '../views/Results.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/:company',
    name: 'First',
    component: First,
    props: true
  },
  {
    path: '/:company/Questions/:number',
    name: 'Questions',
    component: Questions,
    props: true
  },
  {
    path: '/:company/results',
    name: 'Results',
    component: Results
  },
]

const router = new VueRouter({
  routes
})

export default router
